import "./src/styles/global.css"

// Subdomain redirects: epk.magnificentdanger.com → magnificentdanger.com/epk
const SUBDOMAIN_REDIRECTS = {
  epk: "/epk",
};

export const onClientEntry = () => {
  const { hostname, pathname } = window.location;
  const parts = hostname.split(".");
  if (parts.length > 2) {
    const subdomain = parts[0];
    const redirectPath = SUBDOMAIN_REDIRECTS[subdomain];
    if (redirectPath && pathname === "/") {
      const baseDomain = parts.slice(1).join(".");
      window.location.replace(`https://${baseDomain}${redirectPath}`);
    }
  }
};
